import lodash from "lodash";

const KEYCODES = {
  ESC     : 27,
  SPACE   : 32,
  PGUP    : 33,
  PGDN    : 34,
  END     : 35,
  HOME    : 36,
  ENTER   : 13,
  LEFT    : 37,
  UP      : 38,
  RIGHT   : 39,
  DOWN    : 40,
  BS      : 8,
  TAB     : 9,
  DEL     : 46,
  KP2     : 50,
  KBV     : 86,
  KBZ     : 90,
  SHIFT   : 16,
  CTRL    : 17,
  ALT     : 18,
  HYPHEN  : 189,
};

const EVENT_TYPES = {
  KEYDOWN   : "keydown",
  KEYUP     : "keyup",
  KEYINPUT  : "input"
};

const KBD_CONTROL_SCROLL = [
  KEYCODES.UP,
  KEYCODES.DOWN,
  KEYCODES.LEFT,
  KEYCODES.RIGHT,
  KEYCODES.PGUP,
  KEYCODES.PGDN,
  KEYCODES.HOME,
  KEYCODES.END,
  KEYCODES.ENTER,
  KEYCODES.ESC,
];

const state = {
  KEYCODES:     KEYCODES,
  EVENT_TYPES:  EVENT_TYPES,
};

const actions = {
  KBD_INTERRUPT({state}, {event, interrupt, callback}) {
    if (interrupt) {
      if (!interrupt(event, KEYCODES, EVENT_TYPES)) {
        actions.CANCEL_EVENT({state}, {event});
        return false;
      }
    }
    if (callback) {
      callback(event, KEYCODES, EVENT_TYPES);
    }
    return true;
  },
  /* 일반적인 형태의 스크롤제어. 커스터마이징시 해당코드를 복제하여 수정 할것 */
  SIMPLE_KBD_SCROLL({state}, {
    event, index, root, itemQuery, scrollQuery, pointerClass, offsetTop, onSelect, onCancel, callback
  }
    ) {
    /* 200ms 이내 같은 요청이 들어오면 한번만 받아들인다 */
    let fncScroll = lodash.debounce((pointer) => {
      let view = root.querySelector(scrollQuery);
      let item = null;
      let items = root.querySelectorAll(itemQuery);
      for (let inx = 0; inx < items.length; inx++) {
        let tmp = items[inx];
        if (inx === pointer[0]) {
          tmp.classList.add(pointerClass);
          item = tmp;
        }
        else if (tmp && tmp.classList.contains(pointerClass)) {
          tmp.classList.remove(pointerClass);
        }
      }
      if (!item && items.length > 0) {
        item = items[0];
        pointer[0] = 0;
      }
      if (item) {
        let box = item.parentNode;
        let top = item.offsetTop + box.offsetTop + offsetTop;
        if ((top - view.scrollTop) < 0) {
          view.scrollTop = top - 10;
          if (view.scrolTop < 0) { view.scrollTop = 0; }
        }
        else if ((top + item.offsetHeight - view.scrollTop) > view.offsetHeight) {
          view.scrollTop = top + item.offsetHeight - view.offsetHeight + 20;
        }
      }
      else {
        console.log("ERROR! NO ELEMENT ", pointer[0]);
      }
    }, 200);
    actions.KBD_INTERRUPT({state}, {
      event,
      interrupt(event) {
      let ret = true;
      let keyCode = event.keyCode;
      let evtType = event.type;
      let pointer = index;
      let listLength = root.querySelectorAll(itemQuery).length;
      /* 키 다운 이벤트로만 제어 */
      if (evtType === EVENT_TYPES.KEYDOWN) {
        if (keyCode === KEYCODES.UP) {
          if (pointer[0] > 0) {
            pointer[0]--;
            fncScroll(pointer);
          }
          else {
            pointer[0] = 0;
          }
          ret = false;
        }
        else if (keyCode === KEYCODES.DOWN) {
          if (pointer[0] + 1 < listLength) {
            pointer[0]++;
            fncScroll(pointer);
          }
          ret = false;
        }
        else if (keyCode === KEYCODES.LEFT) { /* NOP */ ret = false; }
        else if (keyCode === KEYCODES.RIGHT) { /* NOP */ ret = false; }
        else if (keyCode === KEYCODES.PGUP) {
          if (pointer[0] - 5 > 0) {
            pointer[0] -= 5;
          }
          else {
            pointer[0] = 0;
          }
          fncScroll(pointer);
          ret = false;
        }
        else if (keyCode === KEYCODES.PGDN) {
          if (pointer[0] + 5 < listLength) {
            pointer[0] += 5;
          }
          else {
            pointer[0] = listLength - 1;
          }
          fncScroll(pointer);
          ret = false;
        }
        else if (keyCode === KEYCODES.HOME) {
          pointer[0] = 0;
          fncScroll(pointer);
          ret = false;
        }
        else if (keyCode === KEYCODES.END) {
          pointer[0] = listLength - 1;
          fncScroll(pointer);
          ret = false;
        }
        else if (keyCode === KEYCODES.ENTER) {
          if (onSelect) {
            let element = root.querySelector(itemQuery + "." + pointerClass);
            onSelect(event, pointer, element);
            ret = false;
          }
        }
        else if (keyCode === KEYCODES.ESC) {
          if (onCancel) {
            onCancel(event);
            ret = false;
          }
        }
        else {
          /* 제어키가 아닌 이벤트는 인풋 엘리먼트에 전달된다 */
        }
      }
      else {
        /* 제어키 이벤트는 인풋 엘리먼트 에 전달하지 않는다 */
        if (KBD_CONTROL_SCROLL.indexOf(keyCode) != -1) {
          ret = false;
        }
      }
      return ret;
    }, 
    callback(e) { 
      if (callback) {
        callback(e, fncScroll);
      }
    }
    });
  },
  /**
   * TRIGGER_EVENT 에 어떤 인공적인 이벤트를 전달하여 실제 작동 시킨다던가
   * (예 : 입력창에서 실제 키보드를 누르지 않고 키보드를 누른것 처럼 이벤트를 발생)
   * 누르지 않은 키를 누른것처럼 편법으로 작동하게끔 하기 위해 커스텀 이벤트 객체를 생성
   * 
   * <input @keydown="onKeyDown" value="value"/>
   * 
   * onKeyDown(e) {
   *   if (e.keyCode == KEYCODES.SHIFT) {
   *     console.log("SHIFT 키가 입력되었습니다:", this.value);
   *   }
   * }
   * 
   * 여기서 onKeyDown 을 수행하기 위해서는 input 창에 직접 키보드를 입력해야 하지만
   * 키보드가 눌린것 처럼 작동하게 하기 위해 다음과 같이 처리할 수 있다.
   * 
   * this.onKeyDown(CREATE_EVENT({}, type:{ EVENT_TYPES.KEYDOWN, attr:{ keyCode:KEYCODES.KBZ } }));
   * 
   * 실제에서는 다양한 키눌림 관련 속성을 부여하기 위해 CREATE_EVENT 를 사용한다.
   **/
  CREATE_EVENT({state}, {type, attr, res}) {
    let evt = null;
    if ("createEvent" in document) {
      /* modern browsers, IE9+ */
      evt = document.createEvent("HTMLEvents");
      let bubbles = false;
      let cancelable = true;
      let view  = window;
      let ctrlKey = false;
      let altKey = false;
      let shiftKey = false;
      let metaKey = false;
      let keyCode = 0;
      let charCode = 0;
      for (let k in attr) {
        /* bubble, cancelable, view 등은 읽기전용 속성 */
        if (k == "bubbles")     { bubbles = attr[k]; continue; }
        if (k == "cancelable")  { cancelable = attr[k]; continue; }
        if (k == "view")        { view = attr[k]; continue; }
        if (k == "ctrlKey")     { ctrlKey = attr[k]; }
        if (k == "altKey")      { altKey = attr[k]; }
        if (k == "shiftKey")    { shiftKey = attr[k]; }
        if (k == "metaKey")     { metaKey = attr[k]; }
        if (k == "keyCode")     { keyCode = attr[k]; }
        if (k == "charCode")    { charCode = attr[k]; }
        evt[k] = attr[k];
      }
      evt.initEvent(type, bubbles, cancelable, view,
        ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
    }
    else {
      /* IE 8 */
      evt = document.createEventObject();
      for (let k in attr) { evt[k] = attr[k]; }
      evt.eventType = type;
    }
    if (Array.isArray(res)) { res[0] = evt; }
    return evt;
  },
  /**
   * 커스텀 이벤트 작성용 메소드, 엘리먼트에 키입력을 전달할 경우 사용
   * (예 : 입력창에서 실제 키보드를 누르지 않고 키보드를 누른것 처럼 이벤트를 발생)
   * 
   * 생성된 이벤트를 TRIGGER_EVENT 로 엘리먼트에 전달할수 있다
   * 예 :
   * <input ref="input" value=""/>
   * TRIGGER_EVENT({}, {element:this.$refs.input, type:EVENT_TYPES.KEYDOWN, attr:{ keyCode:KEYCODES.KBZ }});
   * 위 코드가 수행되면 input 창에 'z' 가 찍혀있을것임
   **/
  TRIGGER_EVENT({state}, {element, type, attr}) {
    if (element && attr) {
      let evt = actions.CREATE_EVENT({state}, {type, attr});
      if ("createEvent" in document) {
        element.dispatchEvent(evt);
      }
      else {
        element.fireEvent("on" + evt.eventType, evt);
      }
    }
  },
  CANCEL_EVENT({state}, {event}) {
    event.preventDefault();
    event.stopPropagation();
  },
};
const mutations = {};
const getters = {};
export default { state, actions, mutations, getters, namespaced: true };


// WEBPACK FOOTER //
// ./src/js/store/module/common/evdControl.js